
import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';
import { ModifyTimeGrid, TimeGrid, PostTimeGrid } from 'interfaces/timegrid.interface';
import { API } from 'constants/api.contants';


export class TimeGridService {

  static getTimeGridById(
    timegridId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<TimeGrid> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.TIMEGRID_FULL}/${timegridId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<TimeGrid> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static getTimeGridsBySectorId(
    sectorId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<TimeGrid[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.TIMEGRID_FULL_BY_SECTOR}/${sectorId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<TimeGrid[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data.map( timegrid => { return { ...timegrid }; } ) );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static getEnableTimeGridsBySectorId(
    sectorId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<TimeGrid[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.TIMEGRID_ENABLE_FULL_BY_SECTOR}/${sectorId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<TimeGrid[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data.map( timegrid => { return { ...timegrid }; } ) );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static putTimeGrid(
    timegridId: string,
    timegrid: ModifyTimeGrid,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<{ id: string }> {
    return new Promise( async resolve => {
      AXIOS.put( `${API.TIMEGRID}/${timegridId}`, timegrid, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static postTimeGrid(
    timegrid: PostTimeGrid,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<{ id: string }> {
    return new Promise( async resolve => {
      AXIOS.post( API.TIMEGRID, timegrid, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<{ id: string }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static deleteTimeGrid(
    timegridId: string,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<void> {
    return new Promise( async resolve => {
      AXIOS.delete( `${API.TIMEGRID}/${timegridId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve();
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static deleteTimegridBreaktimes(
    timegridId: string,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<void> {
    return new Promise( async resolve => {
      AXIOS.delete( `${API.TIMEGRID_BREAKTIMES}/${timegridId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve();
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }
};